<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="container-process p-3">
          <div class="row">
            <div class="col-5">
              <label class="data-name">Informe:</label>
              <custom-drop-down
                fieldkey="id"
                fieldname="name"
                :disabled="true"
                v-model="dropDownValue"
              />
            </div>
            <div class="col-4">
              <action-button
                @click="process()"
                :i="'fa fa-sync'"
                class=" mt-4 ml-5 positionButton"
                variant="success"
              >
                Procesar
              </action-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import CustomDropDown from 'custom-drop-down';

// constants
import contentTypes from '@/utils/constants/contentTypes.js';
import axiosResponseTypes from '@/utils/constants/axiosResponseTypes.js';
import subscriptionTypes from '@/utils/constants/subscriptionTypes.js';

export default {
  components: {
    PageHeader,
    ActionButton,
    CustomDropDown,
  },
  data: () => ({
    page: {
      icon: 'fas fas fa-chart-pie',
      title: 'Reporte Vista estudiante',
      routes: ['Informes', 'Reporte Vista estudiante'],
    },
    dropDownValue: null,
  }),
  mounted() {
    this.dropDownValue = {
      id: 0,
      name: 'Vista estudiante',
      directoryName: subscriptionTypes.MentoringMipe.directoryName,
      fileName: subscriptionTypes.MentoringMipe.fileName,
    };
  },
  methods: {
    async process() {
      try {
        const { directoryName, fileName } = this.dropDownValue || {};
        const response = await ReportServices.getReportFile(
          'reportfile',
          {
            DirectoryName: directoryName,
            ReportName: fileName,
            FileName: fileName,
            ContentType: contentTypes.excel,
          },
          axiosResponseTypes.blob
        );
        DocumentServices.DownloadFile(response.data, fileName);
      } catch {
        this.ShowToast(
          '',
          'Ha ocurrido un error descargando el reporte.',
          'error'
        );
      }
    },
  },
};
</script>
<style scoped>
.container-process {
  height: 100px;
  width: 100%;
  background-color: #f4f6f3;
  border-radius: 7px;
}
</style>
